import { axiosWithHeaders } from '@innovyze/lib_get_service';
import config from './config.api';

const rehabService = axiosWithHeaders({
	service: 'amRehab',
	config,
	axiosCreateOpts: {
		timeout: 15000,
	},
});

export default rehabService;
